// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ZWMj","row":"ProcedureTreatmentSummary_row__24wUF"};